/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    CContainer, CBreadcrumb, CBreadcrumbItem,
    CCard, CCardHeader, CCardBody, CRow, CCol
} from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../hooks/useTranslation';
import SampleInputs from '../../components/SampleInputs/SampleInputs';
import { getSampleDropdownRequest, createSampleWithColorsRequest } from '../../store/sample/sampleActions';
import { getSampleDropdown } from '../../services/endpoints';

const CreateSample = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    
    // Redux state
    const { 
        dropdownData, 
        dropdownLoading, 
        dropdownError: storeDropdownError,
        createSampleWithColorsLoading
    } = useSelector(state => state.sampleReducer);
    
    const [compositionOptions, setCompositionOptions] = useState([]);
    const [weaveTypeOptions, setWeaveTypeOptions] = useState([]);
    const [currencyOptions, setCurrencyOptions] = useState([]);
    const [dropdownError, setDropdownError] = useState(null);

    useEffect(() => {
        const sessionUserId = localStorage.getItem('sessionUserId');
        dispatch(getSampleDropdownRequest({ SessionUserId: sessionUserId }));
    }, [dispatch]);

    const refreshDropdownOptions = async (filters = {}) => {
        const sessionUserId = localStorage.getItem('sessionUserId');
        const response = await getSampleDropdown({ SessionUserId: sessionUserId, ...filters });
        const data = response?.data || {};

        if (!filters.WeaveTypeSearchTerm && data.Compositions) setCompositionOptions(data.Compositions);
        if (!filters.CompositionSearchTerm && data.WeaveTypes) setWeaveTypeOptions(data.WeaveTypes);
        if (data.Currencies) setCurrencyOptions(data.Currencies);

        return data;
    };

    // Update dropdown options when Redux state changes
    useEffect(() => {
        if (dropdownData) {
            if (dropdownData.Compositions) setCompositionOptions(dropdownData.Compositions);
            if (dropdownData.WeaveTypes) setWeaveTypeOptions(dropdownData.WeaveTypes);
            if (dropdownData.Currencies) setCurrencyOptions(dropdownData.Currencies);
        }
    }, [dropdownData]);

    // Handle dropdown error
    useEffect(() => {
        if (storeDropdownError) {
            setDropdownError('Dropdown verileri alınamadı.');
        }
    }, [storeDropdownError]);

    const handleSubmit = (data) => {
        const sessionUserId = localStorage.getItem('sessionUserId');
        
        // Prepare sample data (exclude table data for sample creation)
        const samplePayload = {
            SessionUserId: sessionUserId,
            CardNo: data.CardNo || '',
            CompanyName: data.CompanyName || '',
            Note: data.Note || '',
            Certificate: data.Certificate || '',
            FabricWidth: data.FabricWidth || '',
            FabricWeight: data.FabricWeight || '',
            ReedWidth: data.ReedWidth || '',
            Price: data.Price || '',
            Datetime: data.Datetime || '',
            CompositionGuid: data.CompositionGuid || '',
            WeaveTypeGuid: data.WeaveTypeGuid || '',
            CurrencyGuid: data.CurrencyGuid || '',
            Photo: data.Photo || null,
            TotalThread: data.TotalThread || '',
            ReedNo: data.ReedNo || '',
            Dgts: data.Dgts || '',
            WarpDensity: data.WarpDensity || '',
            WeftDensity: data.WeftDensity || '',
            GrayWarp: data.GrayWarp || '',
            GrayWeft: data.GrayWeft || ''
        };

        dispatch(createSampleWithColorsRequest({
            sampleData: samplePayload,
            tableData: data.allTableData || [],
            sampleFactorRowsByThreadType: data.sampleFactorRowsByThreadType || { 1: [], 2: [] },
            navigate,
            sessionUserId,
            cardNo: data.CardNo
        }));
    };

    const handleCancel = () => {
        navigate('/samples');
    };

    return (
        <CContainer>
            <CBreadcrumb className="mb-4">
                <CBreadcrumbItem
                    href="#/samples"
                    onClick={e => { e.preventDefault(); handleCancel(); }}
                >
                    {t('samples')}
                </CBreadcrumbItem>
                <CBreadcrumbItem active>{t('createSample')}</CBreadcrumbItem>
            </CBreadcrumb>
            <CRow>
                <CCol xs={12}>
                    <CCard>
                        <CCardHeader><h4>{t('createSample')}</h4></CCardHeader>
                        <CCardBody>
                            <SampleInputs
                                onSubmit={handleSubmit}
                                onCancel={handleCancel}
                                isLoading={createSampleWithColorsLoading}
                                compositionOptions={compositionOptions}
                                weaveTypeOptions={weaveTypeOptions}
                                currencyOptions={currencyOptions}
                                dropdownLoading={dropdownLoading}
                                dropdownError={dropdownError}
                                onDropdownRefresh={refreshDropdownOptions}
                            />
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>
        </CContainer>
    );
};

export default CreateSample;
